module.exports = __webpack_public_path__ + "static/media/mini-banner.35d6b11f.svg";